<template>
  <div v-if="hasPermission(permissions.leadSubSourcesCreate)">
    <content-header>{{ $t('editSubLeadSource') }}</content-header>
    <v-content>
      <b-card>
        <b-card-body>
          <form class="forms-sample" @submit.prevent="onSubmit">
            <text-input id="name" :name="$t('name')" :validate="$v" :required="true" :is-loading="isLoading" />
            <select-input
                id="leadSource"
                :name="$t('leadSource')"
                label="name"
                :validate="$v"
                :required="true"
                api-link="leadSources/GET_ALL"
                :default-value="form.leadSource"
                @itemSelected="$e => this.form.leadSourceId = $e"
                :is-loaded="isLoading"
            />
            <submit-input icon="fa-save" :name="$t('save')" :disabled="isLoading"/>
            <is-loading v-if="isLoading" />
          </form>
        </b-card-body>
      </b-card>
    </v-content>
  </div>
</template>

<script>
import Content from "@/components/Content";
import ContentHeader from "@/components/ContentHeader";
import { required } from 'vuelidate/lib/validators'
import IsLoading from "@/components/IsLoading";
import {LeadSubSource} from "@/models/LeadSubSource";
import SelectInput from "@/components/Inputs/SelectInput";
import TextInput from "@/components/Inputs/TextInput";
import SubmitInput from "@/components/Inputs/SubmitInput";
import {permissions} from "@/plugins/constants";

export default {
  name: "LeadSubSourceEdit",
  components: {SubmitInput, TextInput, ContentHeader, 'v-content': Content, IsLoading, SelectInput},
  data() {
    return {
      form: this.$helpers.convertArrayToObject(new LeadSubSource().fillAbles),
      isLoading: false,
      permissions: permissions
    };
  },
  validations: {
    form: {
      name: {required},
      leadSourceId: {required}
    }
  },
  mounted() {
    this.isLoading = true;
    this.$store.dispatch('leadSubSources/GET_ONE', this.$route.params.id).then((response) => {
      this.form               = response.data;
      this.form.leadSourceId  = response.data.leadSourceId
      this.isLoading          = false;
    }).catch(() => this.isLoading = false)
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$pending || this.$v.$error) return false;
      this.isLoading = true;
      this.$store.dispatch('leadSubSources/UPDATE', {id: this.$route.params.id, form: this.form}).then(() => {
        this.$v.$reset();
        this.$router.push({name: "leadSubSources"})
      }).catch(() => this.isLoading = false);
    },
  }
}
</script>
